export default __webpack_public_path__ + "static/media/cernova.35174853.png";